import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("SelectOptionWidget", {
  title: "Select Option",
  attributes: {
    text: {
      title: "Text",
      description: "This is the value that will be displayed in the form",
    },
  },
  properties: ["text"],
  initialContent: {
    text: "Option",
  },
  validations: [
    [
      "text",
      (text) => {
        if (!text) {
          return "Text field is required";
        }
        return null;
      },
    ],
  ],
});
